module.exports = __webpack_public_path__ + "img/home_poster.7bcacac2.jpg";